export default [
  {
    name: "companies",
    meta: {
      title: "Manage Companies",
    },
    path: "/manage/companies",
    component: () => import("@/views/pages/companies"),
  },
  {
    name: "Company",
    meta: {
      title: "Company",
    },
    path:"/manage/company/:business_id",
    component: () => import("@/views/pages/companies/company.vue"),
  }
];
